export default {
  menuItem: {
    account: 'Account Settings',
    billing: 'Billing & Payments',
    organizations: 'Organizations',
    preference: 'Preference',
    organization: 'Your organizations',
    logout: 'Logout',
  }
}